// extracted by mini-css-extract-plugin
export default {"BtnPrimary":"Style_BtnPrimary__o09lD","BtnSecondary":"Style_BtnSecondary__pdexJ","BtnLink":"Style_BtnLink__y39if","danger":"Style_danger__mf4aa"};